import React from 'react';
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { fetchJson } from "../../../../helpers";
import NoDataComponent from "../../no_data_component";
import titleFontSize from '../base/titleFontSize.js';
import ProjectDiscussion from '../../../common/LiveDiscussion/ProjectDiscussion.jsx';
import {
    live_discussion_get_props_path,
    live_discussion_get_unread_discussions_path
} from '~/routes';

function DiscussionWidget({ widgetId }){
  const projectId = useSelector(state => state.dashboard.projectId);
  const title = useSelector(state => state.dashboard.widgets[widgetId]?.title) || {};
  const renderFontSize = titleFontSize(title.fontSize);

  const {data: discussionProps = {}} = useQuery({
      queryKey: ['discussionProps'],
      queryFn: async () => {
          return await fetchJson(live_discussion_get_props_path({project_id: projectId}))
      }
  })
  const {data: unreadDiscussions = []} = useQuery({
      queryKey: ['unreadDiscussions'],
      queryFn: async () => {
          const res = await fetchJson(live_discussion_get_unread_discussions_path({target_type: 'programme', target_id: projectId}))
          return res?.unread_discussion
      },
      enabled: discussionProps.permissions?.view,
      refetchOnMount: true,
      staleTime: 60 * 1000 // reduce staleTime to 1 min so new discussion get updated frequently 
  })

  return (
    (discussionProps.permissions || {}).view ?
    <div style={{display:'flex', flexDirection: 'column', padding: '10px', height: '100%'}}>
        <div className="programme-discussion-header mb-1">
            <div className="text-truncate ml-1 pull-left">
                <h4 
                className='text-truncate cursor-pointer d-flex'
                style={{fontSize: renderFontSize}}>
                    <span>{title.text || I18n.t('discussions')}</span>
                    {unreadDiscussions.length > 0 && <span className="unread-icon">{unreadDiscussions.length}</span>}
                </h4>
            </div>
        </div>
        <div className='event-feeds-widget'>
            <ProjectDiscussion 
                target_type='programme'
                target_id={projectId} 
                person_id={discussionProps.person_id} 
                permissions = {discussionProps.permissions}
                is_fund_staff={discussionProps.is_fund_staff}
                unreadDiscussions={unreadDiscussions}
                dashboard_gen2={true}
            />
        </div>
    </div> : <NoDataComponent text={I18n.t('access_denied_facility_discussion')} />
  )
}

export default DiscussionWidget;
